import { Component, OnInit } from '@angular/core';

import { Modal } from 'bootstrap';

import { StateService } from 'src/app/services/state.service';
import { TutorialsService } from 'src/app/services/tutorials.service';

import { Tutorial, TutorialSection } from 'src/app/interfaces/tutorial';

@Component({
  selector: 'app-tutorials',
  templateUrl: './tutorials.component.html',
  styleUrls: ['./tutorials.component.scss'],
})
export class TutorialsComponent implements OnInit {
  sections: TutorialSection[] = [];
  loading: boolean = false;

  tutorialTypeDict: any = {
    SHORT_VIDEO: 'Video Corto',
    LONG_VIDEO: 'Video Largo',
    PDF: 'PDF',
  };

  allowedUserTypeDict: any = {
    USER: 'App para usuarios',
    TABLET: 'Tablet en Gym',
    USER_TABLET: 'Tablet y App',
  };

  constructor(
    private stateService: StateService,
    private tutorialsService: TutorialsService
  ) {}

  ngOnInit(): void {
    this.loading = true;
    this.setEventListener();
  }

  setEventListener() {
    const modalElement = document.getElementById('tutorialsModal');

    modalElement!.addEventListener('shown.bs.modal', () => {
      this.getAllTutorials();
    });
  }

  getAllTutorials() {
    this.loading = true;

    this.tutorialsService.getAllTutorials().subscribe({
      next: (sections: TutorialSection[]) => {
        this.loading = false;
        this.sections = sections;

        this.sections.forEach((s: TutorialSection) => {
          if (s.tutorials) {
            s.tutorials.forEach((t: Tutorial) => {
              t.formatSpanish = this.tutorialTypeDict[t.format];
              t.allowedUserTypeSpanish =
                this.allowedUserTypeDict[t.allowedUserType!];
            });
          }
        });
      },
    });
  }

  deleteTutorial(section: TutorialSection, tutorial: Tutorial) {
    if (window.confirm('¿Segúro que quieres eliminar este tutorial?')) {
      this.tutorialsService.deleteTutorial(tutorial).subscribe({
        next: () => {
          section.tutorials = section.tutorials!.filter(
            (t: Tutorial) => t.id != tutorial.id
          );
        },
      });
    }
  }

  // selectTutorial(tutorial: Tutorial) {
  //   this.stateService.selectedTutorial = tutorial;

  //   this.openCompleteTutorialsForm();
  // }

  openCompleteTutorialsForm() {
    this.stateService.openModal.hide();

    const completeTutorialsModal = new Modal('#completeTutorialsFormModal');
    this.stateService.openModal = completeTutorialsModal;

    completeTutorialsModal.show();
  }
}
